import { render } from "./Background.vue?vue&type=template&id=00ddc30d&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=00ddc30d&lang=scss&scoped=true"

import exportComponent from "E:\\Project-humblit_official_system\\humblit_official_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ddc30d"]])

export default __exports__